<template>
  <div id="searchBar" class="flex">
    <img :src="Logo" alt="">
    <router-link to="" class="searchBar__input">
      <span class="iconfont icon-sousuo"></span><input type="text" placeholder="请输入关键词查询" @focus="search_show()" v-model="search_val" >
      
    </router-link>
    <span v-if="search_btn_show" class="search_btn" @click="search()">搜索</span>
  </div>
</template>

<script>
  export default {
    name: "searchBar",
    props:{
      searchLogo:{
        default: '/static/img/logo.png',
        type: String,
        
      },
    
    },
    data(){
        return{
          sysset:[],
           Logo:'',
           search_btn_show:false,
           search_val:''
        }
    },
    created(){
      this.Logo = this.searchLogo;
      this.sysset = this.$route.query.id;

      this.axios({
          url: this.api.sysset.sysset_shop,
          data:{
            
          }
      }).then((res) => {
          if (res.error === 0) {
            this.sysset  = res.sysset
            this.Logo = res.sysset.logo
          }

      })
    },
    methods: {
      search_show(){
         this.search_btn_show = true
      },
      search(){
        this.$router.push({path:'./search',query:{'search_val':this.search_val}});
      }
    },
  }
</script>

<style scoped>
  #searchBar{
    width: 100%;
    height: 2.5rem;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 66;
    padding: 0 .75rem;
    background: #f4f5f6;
    border-bottom: 1px solid rgba(231,231,231,1);
  }
  #searchBar img{
    width: 2rem;
    margin-right: .5rem;
  }
  .search_btn{
      width: 18%;
      background: #45b9bc;
      margin-left: 0.5rem;
      font-size: 0.75rem;
      padding: 0.25rem;
      border-radius: 0.2rem;
      text-align: center;
      color: white;
  }
  .searchBar__input{
    display: flex;
    align-items: center;
    width: 100%;
    background: #fff;
    border: 1px solid #ededed;
    height: 1.8rem;
    border-radius: .25rem;
  }
  .searchBar__input span{
    margin: 0 .35rem;
    color: #ccc;
    font-size: .9rem;
  }
  .searchBar__input input{
    width: 90%;
    height: 100%;
    font-size: .7rem;
    padding-right: .5rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/searchBar.vue